export const headerData = ['Type', 'No. Reports', 'Updated At', ''];
